import {PersonalityType} from "../enums/personalityType.enum";
import {UserCategoryResultPublic} from "../models/userResults/userCategoryResultPublic.model";

class ProfileHelper {
    static getPersonalityTypeParts(MBTI: string) {
        return MBTI.toUpperCase().split('').map((char, index) => {
            switch (char) {
                case 'I':
                {
                    return PersonalityType.I;
                }
                case 'E':
                {
                    return PersonalityType.E;
                }
                case 'S':
                {
                    return PersonalityType.S;
                }
                case 'N':
                {
                    return PersonalityType.N;
                }
                case 'T':
                {
                    return PersonalityType.T;
                }
                case 'F':
                {
                    return PersonalityType.F;
                }
                case 'J':
                {
                    return PersonalityType.J;
                }
                case 'P':
                {
                    return PersonalityType.P;
                }
            }
        });
    }
    
    static getCategoryNamesFromUserCategoryResults(userCategoryResults?: UserCategoryResultPublic[]) {
        
        if(userCategoryResults == null || !userCategoryResults.length) {

            return {
                mbti: undefined,
                sunSign: undefined,
                moonSign: undefined,
                risingSign: undefined,
                loveLanguage1: undefined,
                loveLanguage2: undefined,
                loveLanguage3: undefined,
                persona: undefined
            };
        }
        
       const mbti = userCategoryResults.find(r => r.categoryName === "MBTI")?.response;
       const sunSign = userCategoryResults.find(r => r.categoryName === "Sun Sign")?.response;
       const moonSign = userCategoryResults.find(r => r.categoryName === "Moon Sign")?.response;
       const risingSign = userCategoryResults.find(r => r.categoryName === "Rising Sign")?.response;
       const loveLanguage1 = userCategoryResults.find(r => r.categoryName === "Love Language #1")?.response;
       const loveLanguage2 = userCategoryResults.find(r => r.categoryName === "Love Language #2")?.response;
       const loveLanguage3 = userCategoryResults.find(r => r.categoryName === "Love Language #3")?.response;
       const persona = userCategoryResults.find(r => r.categoryName === "Persona")?.response;
        
        return {
            mbti,
            sunSign,
            moonSign,
            risingSign,
            loveLanguage1,
            loveLanguage2,
            loveLanguage3,
            persona
        };
    }
}

export {ProfileHelper}